<template>
  <div class="view-list" :class="{'view-filter': !isEmpty, 'fixed':isFixed}" :style="`background-color:${theme.bgColor}`">
    <gallery-view ref="gallery" :theme="theme" :sort="sort" :column="column" @change="galleryChange" @gallerySort="gallerySort"></gallery-view>
    <waterfall
      v-if="!isEmpty"
      :col='column'
      @loadmore="loadmore"
      @finish="finish"
      :total="total"
      :data="list">
      <template >
        <div class="view-list-item" v-for="(item, index) in list" :key="item.id" @click="goToDetail(item, index)">
          <div v-if="isGroup">
            <img v-if="item.image_type == 'image'" class="view-image" :src="item.url + thumail" :alt="item.name" />
            <div v-else class="view-video">
              <video class="view-image" :src="item.url" :poster="item.thumbnail_url" />
            </div>
          </div>
          <div v-else>
            <div class="view-group" v-if="item.is_photo_group">
              <img class="view-image" :src="item.thumbnail_url" :alt="item.name">
            </div>
            <img v-else-if="item.image_type == 'image'" class="view-image" :src="item.url + thumail" :alt="item.name" />
            <div v-else class="view-video">
              <video class="view-image" :src="item.url" :poster="item.thumbnail_url" />
            </div>
          </div>
        </div>
      </template>
    </waterfall>
    <div v-else class="empty">
      <div class="empty-banner">
        <img class="empty-img" src="@/assets/image/empty.png" alt="">
        <div class="tips">
          <p>宝宝没有找到您的影集</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GalleryView from '@/components/galleryView.vue'
import API from '@/service/API'
import '@/assets/less/viewList.less'
export default {
  data(){
    return {
      banner: [],
      column: 2,
      thumail: '?x-oss-process=style/thumail_twolist',
      top: 0,
      isEmpty: false,
      isFixed: false
    }
  },
  props: {
    list: Array,
    total: Number,
    page: Number,
    filter: Boolean,
    isGroup: Boolean,
    type: String,
    sort: Boolean,
    theme: {
      type: Object,
      default: function(){
        return {
          footerColor: "#fff",
          bgColor: "#fff",
          searchBgColor: "#fff"
        }
      }
    }
  },
  mounted(){
    const gallery = this.$refs.gallery.$el;
    let data = this.$data
    document.addEventListener("scroll",() => {
      if(data.top == 0){
        data.top = gallery.offsetTop;
      }
      const scrollTop = document.documentElement.scrollTop;
      if(scrollTop > data.top){
        data.isFixed = true
      } else{
        data.isFixed = false
      }
    })
  },
  components: {
    GalleryView,
  },
  methods:{
    galleryChange(item) {
      this.column = item.value
      this.thumail = item.suffix
    },
    gallerySort(flag) {
      this.$emit('gallerySort', flag)
    },
    goToDetail(item, index){
      if(!this.isGroup && item.is_photo_group){
        this.$router.push({
          name: 'group',
          params: {
            albumId: item.album,
            id: item.photo_group,
          }
        })
      }else{
        this.$router.push({
          name: 'detail',
          params:{
            albumId: item.album,
            id: item.id,
            currentIndex: index,
            currentItem: item,
            list: this.list,
            total: this.total,
          },
          query:{
            type: this.$props.type,
            page: this.$props.page
          }
        })
      }
    },
    loadmore(){
      this.$emit('loadmore')
    },
    finish(){
      this.$emit('finish')
    }
  }

}
</script>

<style>

</style>